import React from 'react';

import type { InstagramPostComponentsProps } from './types';

export function Header(_props: InstagramPostComponentsProps): React.JSX.Element {
	return <div>Instagram Post Header</div>;
}
